<template>
  <TopBlock
    type="buyer"
    :title="$t('components.info.buyerPage.title')"
    :subtitle="$t('components.info.buyerPage.subtitle')"
  />

  <AnchorList :list="buyerAnchorList" />

  <WhatIsOskelly />

  <HowTo type="buy" />

  <OskellyExpertise type="buy" />

  <SafeDeal />

  <DeliveryAndRefund />

  <OfferYourPrice />

  <UsefulTips type="buy" />
</template>

<script setup lang="ts">
import { buyerAnchorList } from '~/components/info/anchors';

import AnchorList from '~/components/info/AnchorList.vue';
import DeliveryAndRefund from '~/components/info/DeliveryAndRefund.vue';
import HowTo from '~/components/info/HowTo.vue';
import OskellyExpertise from '~/components/info/OskellyExpertise.vue';
import SafeDeal from '~/components/info/SafeDeal.vue';
import TopBlock from '~/components/info/TopBlock.vue';
import UsefulTips from '~/components/info/UsefulTips.vue';
import WhatIsOskelly from '~/components/info/WhatIsOskelly.vue';
import OfferYourPrice from '~/components/info/OfferYourPrice.vue';

useHead({
  title: 'Покупайте на Oskelly – Интернет-магазин Oskelly',
  meta: [
    {
      name: 'description',
      content: 'Покупайте на Oskelly – Интернет-магазин Oskelly',
    },
  ],
});
</script>
